import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
    marginBottom: theme.spacing[2],
    "&:last-child": {
        marginBottom: 0,
    },
    label: {
        display: "block",
        lineHeight: 1.5,
    },
    "&:nth-child(2)": {
        marginTop: `-${theme.spacing[1.5]}`,
        color: theme.colors.gray[500],
        [`${Caption}`]: {
            fontWeight: theme.fontWeight.normal,
        },
    },
}));

export const Body = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    fontSize: theme.fontSize.xs,
    gap: theme.spacing[1],
}));

export const Caption = styled("div")(({ theme }) => ({
    fontWeight: theme.fontWeight.medium,
}));

export const Icon = styled("div")(({ theme }) => ({
    shrink: 0,
    width: theme.spacing[3],
    height: theme.spacing[3],
    borderRadius: theme.borderRadius.DEFAULT,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.colors.gray[500],
    svg: {
        height: theme.spacing[2],
        width: theme.spacing[2],
        color: theme.colors.white,
    },
}));
